import { ClientAwareEvaluatorAttribute, ClientAwareEvaluatorAttributePropertyValues, IClientAwareEvaluatorAttribute } from "./ClientAwareEvaluatorAttribute";
import { NAMESPACE } from "./_Namespace";

export type ClientAwareMandatoryEvaluatorAttributePropertyValues =
    ClientAwareEvaluatorAttributePropertyValues
    & {
    };

export type ClientAwareMandatoryEvaluatorAttributeProperties = {
    [name in keyof ClientAwareMandatoryEvaluatorAttributePropertyValues]?: ClientAwareMandatoryEvaluatorAttributePropertyValues[name];
};

export interface IClientAwareMandatoryEvaluatorAttribute extends IClientAwareEvaluatorAttribute, ClientAwareMandatoryEvaluatorAttributeProperties
{
}

export class ClientAwareMandatoryEvaluatorAttribute extends ClientAwareEvaluatorAttribute implements IClientAwareMandatoryEvaluatorAttribute
{
    public static override classNamespace = NAMESPACE + "ClientAwareMandatoryEvaluatorAttribute";
    public static override className = "ClientAwareMandatoryEvaluatorAttribute";
}